import { type HTMLAttributes, type ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hoverable?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

export function Card({
  children,
  hoverable = false,
  padding = 'md',
  className,
  ...props
}: CardProps) {
  return (
    <div
      className={clsx(
        styles.card,
        hoverable && styles.hoverable,
        padding !== 'none' && styles[`pad-${padding}`],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
